import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { getXOffset, getYOffset } from './blobUtils';
import { InnerBlob } from './BlobPaths';
import { BlobSvg } from './Blob.styles';
export const InnerSvg = ({
  messageKey,
  children,
  color
}) => {
  const yOffset = getYOffset(messageKey) || 0;
  const xOffset = getXOffset(messageKey) || 0;
  return /*#__PURE__*/_jsxs(BlobSvg, {
    "aria-hidden": "true",
    viewBox: InnerBlob.viewBox,
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "innerBlob",
        children: /*#__PURE__*/_jsx("path", {
          d: InnerBlob.path,
          fill: color,
          transform: `translate(${-661.14 - xOffset} ${-380.79 - yOffset})`
        })
      })
    }), /*#__PURE__*/_jsx("path", {
      d: InnerBlob.path,
      fill: color,
      transform: InnerBlob.transform
    }), children]
  });
};